import connectHits from 'instantsearch.js/es/connectors/hits/connectHits.js';
import { useConnector } from '../hooks/useConnector.js';

function useHits(props, additionalWidgetProperties) {
    return useConnector(connectHits, props, additionalWidgetProperties);
}

export { useHits };
